import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	ns: ["translations"],
	resources: messages,

	// — Trava contra "Cannot read properties of undefined (reading 'translations')"
	// quando o navegador do usuário entrega um dialeto completo ("pt-BR", "pt-PT",
	// "es-AR", "en-US") que não existe como chave direta em `resources`.
	// Sem isto: i18n procura resources["pt-BR"].translations → undefined → crash.
	// Com `load: "languageOnly"`: ele pede só "pt", "en", "es" (o que temos).
	// Com `supportedLngs` + mapa de fallback: dialetos caem no idioma base,
	// e línguas totalmente desconhecidas (ex: fr, it) vão para "en".
	load: "languageOnly",
	supportedLngs: ["pt", "en", "es"],
	nonExplicitSupportedLngs: true,
	fallbackLng: {
		"pt-BR": ["pt"],
		"pt-PT": ["pt"],
		"pt-AO": ["pt"],
		"pt-MZ": ["pt"],
		"es-AR": ["es"],
		"es-MX": ["es"],
		"es-ES": ["es"],
		"es-CL": ["es"],
		"es-CO": ["es"],
		"en-US": ["en"],
		"en-GB": ["en"],
		"en-CA": ["en"],
		default: ["en"],
	},

	fallbackNS: "translations",
	returnEmptyString: false,
	returnNull: false,

	// O detector guarda o idioma escolhido em localStorage por padrão. Aqui o
	// localStorage não é usado para nada: cookie faz o mesmo trabalho e mantém
	// um só lugar de armazenamento no navegador.
	detection: {
		order: ["cookie", "navigator", "htmlTag"],
		caches: ["cookie"],
		lookupCookie: "i18nextLng",
		checkWhitelist: true,
	},
});

export { i18n };
